import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { YOLANDA_FOOTER_BAND } from "@/data/config";

/**
 * Full-bleed cinematic Yolanda band. Sits directly above the site footer
 * on the Home page to close the experience on her face — the signature.
 */
export default function YolandaBand() {
  return (
    <section
      className="relative w-full bg-black overflow-hidden"
      data-testid="yolanda-footer-band"
    >
      <motion.img
        initial={{ scale: 1.04, opacity: 0.85 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 1.4, ease: [0.7, 0, 0.2, 1] }}
        src={YOLANDA_FOOTER_BAND}
        alt="Yolanda Campbell — Founder, Master Cosmetologist, Barber"
        className="w-full h-auto block select-none"
        draggable={false}
      />
      <div className="absolute inset-x-0 bottom-0 h-24 md:h-40 bg-gradient-to-b from-transparent to-black pointer-events-none" />
      <div className="absolute inset-x-0 bottom-6 md:bottom-10 flex justify-center pointer-events-none">
        <Link
          to="/founder"
          className="btn-ghost inline-flex items-center gap-2 pointer-events-auto"
          data-testid="yolanda-band-cta"
        >
          Meet Yolanda
          <ArrowUpRight className="w-4 h-4" strokeWidth={1.4} />
        </Link>
      </div>
    </section>
  );
}
